import cookies from 'cookies-js';

// set the cookie from query parameters
export default function setCookiesForPartnerPages() {
  const searchParams = new URLSearchParams(window.location.search);
  const expiration = new Date(
    new Date().getTime() + 30 * 24 * 60 * 60 * 1000
  ).toUTCString();

  const cookieAttr = { httpOnly: true, expires: expiration, secure: true };

  if (searchParams.get('partnerId') || searchParams.get('partnerID'))
    cookies.set(
      'param1',
      searchParams.get('partnerId') || searchParams.get('partnerID'),
      { cookieAttr }
    );
  if (searchParams.get('param2') || searchParams.get('AID'))
    cookies.set(
      'param2',
      searchParams.get('param2') || searchParams.get('AID'),
      { cookieAttr }
    );
  if (searchParams.get('param3') || searchParams.get('PID'))
    cookies.set(
      'param3',
      searchParams.get('param3') || searchParams.get('PID'),
      { cookieAttr }
    );
  if (searchParams.get('progId') || searchParams.get('progID'))
    cookies.set(
      'progId',
      searchParams.get('progId') || searchParams.get('progID'),
      { cookieAttr }
    );
  if (searchParams.get('reg_referrer') || searchParams.get('lc_referrer'))
    cookies.set(
      'reg_referrer',
      searchParams.get('reg_referrer') || searchParams.get('lc_referrer'),
      { cookieAttr }
    );
}
